<template>
  <div class="auth-upload">
    <div class="auth-upload-content" @click="upload">
      <div v-if="!imageUrl" class="auth-upload-box">
        <img v-if="type === 1" :src="this.provide ? require('../../assets/ciba/add-posi.png'):require('../../assets/images/authentication/add-posi.png')" alt="">
        <img v-else :src="this.provide ? require('../../assets/ciba/add-nega.png'):require('../../assets/images/authentication/add-nega.png')" alt="">
        <p>上传身份证{{type === 1? '人像': '国徽'}}面</p>
      </div>
      <img v-if="imageUrl" :src="imageUrl" alt="">
      <div class="auth-upload-mask" v-if="imageUrl">
        <img src="../../assets/images/authentication/check.png" alt="">
        <h5>上传成功</h5>
        <p>（点击可重新上传）</p>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@edu-fe/api'
export default {
  name: 'AuthUpload',
  data() {
    return {
      imageUrl: '',
    }
  },
  computed: {
    provide () {
      return this.$route.query.provide === 'ciba'
    }
  },
  props: {
    // 身份证类型 1 正面 2 反面
    type: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    convertBase64UrlToBlob(data) {
      let base64Data = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? data.split(',')[1] : data
      var bstr = atob(base64Data),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: 'image/png' });
    },


    // async send(name, file) {
    //   const { data: url, msg: key } = await api.authentication.getUrl(name)()
    //   let formData = new FormData()
    //   let _blob = this.convertBase64UrlToBlob(decodeURIComponent(file))

    //   formData.append(this.imageUrl, _blob)
    //   api.authentication.upload(url, formData, _blob.size)()
    // },
    async sendBack(file) {
      var formData = new FormData();
      // formData.append("myfile", this.convertBase64UrlToFile(file));
      const fileName = this.imageUrl.split('/')
      console.log()
      formData.append("myfile", this.convertBase64UrlToBlob(file), `${fileName[fileName.length - 1]}.png`);
      const data = await api.authentication.uploadBack(formData)()
      this.$emit('sendOut', data.data, this.type)
    },
    upload() {
      wx.chooseImage({
        count: 1, // 每次只处理一张照片
        sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: res => {
          const _res = res
          // this.imageUrl = _res.localIds[0]
          this.imageUrl = _res.localIds[0]
          wx.getLocalImgData({
            localId: res.localIds[0],
            success: res => {
              // this.send(_res.localIds[0], res.localData)
              this.sendBack(res.localData)
            },
            fail: res => {
              alert(JSON.stringify(res));
            }
          });

          // wx.uploadImage({
          //   localId: res.localIds[0],
          //   success: res => {
          //     this.imageUrl = _res.localIds[0]
          //     console.log(`upload finish`)
          //     this.$emit('sendOut', res.serverId, this.type)
          //     // res.serverId
          //     // 下面处理自己服务器的数据请求
          //   },
          //   fail: res => {
          //     alert(JSON.stringify(res));
          //   }
          // });

        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "../../style/main";

  .auth-upload {
    width: use(612);
    height: use(316);
    background: #FFF;
    border-radius: use(20);
    box-shadow: 0 use(6) use(10) 0 rgba(#000, 0.05);
    text-align: center;
    padding: use(10);
    box-sizing: border-box;
    margin: 0 auto;

    &-content {
      width: use(590);
      height: use(295);
      border-radius: use(10);
      position: relative;

      >img {
        width: 100%;
        height: 100%;
      }
    }

    &-box {
      width: 100%;
      height: 100%;
      border: use(2) dashed #E5E5E5;
      border-radius: use(10);

      img {
        width: use(238);
        height: use(142);
        margin-top: use(64);
      }

      p {
        font-size: use(28);
        color: #4A4A4A;
        letter-spacing: use(1);
        line-height: 1.7;
      }
    }

    &-mask {
      width: 100%;
      height: 100%;
      background-color: rgba(#000, 0.45);
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      padding-top: use(84);

      img {
        width: use(56);
        height: use(56);
        margin-bottom: use(10);
      }

      h5 {
        font-weight: bold;
        font-size: use(30);
        color: #FFFFFF;
        margin-bottom: use(30);
      }

      p {
        font-size: use(22);
        color: #F8E71C;
      }
    }
  }
</style>
